import { format } from 'date-fns'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface ShiftTimelineState {
  selectedDate: string
  hideOffShiftCallsigns: boolean
  setSelectedDate: (selectedDate: string) => void
  setHideOffShiftCallsigns: (hide: boolean) => void
}

const todayDate = () => format(new Date(), 'yyyy-MM-dd')

export const useShiftTimelineStore = create<ShiftTimelineState>()(
  persist(
    (set) => ({
      selectedDate: todayDate(),
      hideOffShiftCallsigns: false,
      setSelectedDate: (selectedDate) =>
        set({
          selectedDate,
        }),
      setHideOffShiftCallsigns: (hideOffShiftCallsigns) =>
        set({
          hideOffShiftCallsigns,
        }),
    }),
    {
      name: 'rrms-shift-timeline',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        selectedDate: state.selectedDate,
        hideOffShiftCallsigns: state.hideOffShiftCallsigns,
      }),
    }
  )
)
